<template>
  <div class="treeview w-100 m-3">
    <ul class="list-group">
      <li v-for="c in children" :key="c.id" ref="childitems" class="list-group-item treeitem" v-bind:class="{active: c.id == treestate.id}">
        <font-awesome-icon v-if="!c.expanded" @click="expands(c)" class="mr-2 clickable" icon="plus"/>
        <font-awesome-icon v-if="c.expanded" @click="collapse(c)" class="mr-2 clickable" icon="minus"/>
        <strong class="clickable" @click="selectNode(c)">{{ c.name }} </strong>
        <CTreeItem ref="childrefs" v-if="c.expanded && c.children && c.children.length > 0" :depth="Number(depth)+Number(1)" @selectnode="selectNode" :parent="c.id" :treeid="treeid" :treestate="treestate"/>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.treeview li.treeitem:not(.active) {
    color: black;
}

.treeview li.treeitem:hover:not(.active) {
  background-color: #eee;
}

.clickable {
  cursor: pointer;
}
</style>

<script>
import config from '@/modules/config.js'

export default {
  name: 'CTreeItem',
  props: ['parent','treeid','treestate','depth'],
  data() {
    return {
      children: [],
      childrefs: []
    }
  },
  watch: {
    // check for path activations
    treestate: function(nval) {
      if (nval.path) {
        this.checkpath(nval.path);
      }
    }
  },
  mounted: function() {
    console.log('items:');
    this.reload();
  },
  methods: {
    checkpath: function(path) {
      if (path) {
        console.log('update tree state ' + this.children.length + '/' + this.depth);
        for (var i in this.children) {
          var c = this.children[i];
          console.log(c.id + ' <> ' + path[this.depth]);
          if (c.id == path[this.depth]) {
            console.log('found child: ' + c.id);
            if (path.length == this.depth + 1) {
              this.selectNode(c);
            } else {
              if (!c.expanded) {
                this.expands(c);
              }
            }
          }
        }
      }
    },
    selectNode: function(child) {
      console.log(child);
      this.$emit('selectnode',child);
    },
    expands: function(node,cb) {
      // check loaded
      if (!node.children) {
        var self = this;
        config.get(this,config.baseUrl + 'rest/ctree/nodes/' + encodeURIComponent(this.treeid) + '/' + encodeURIComponent(node.id) + '/childs','Kategoriebaum laden.',function(data) {
          node.children = data;
          console.log('loaded childs' + data.length);
          self.expands(node,cb);
        });
        return;
      }
      node.expanded = true;
      this.$forceUpdate();

      console.log('expand: ' + cb);
      if (cb) {
        cb();
      }
    },
    collapse: function(node) {
      node.expanded = false;
      this.$forceUpdate();
    },
    // expands and loads a subtree
    reload: function() {
      var self = this;
      config.get(this,config.baseUrl + 'rest/ctree/nodes/' + encodeURIComponent(this.treeid) + '/' + encodeURIComponent(this.parent) + '/childs','Kategoriebaum laden.',function(data) {
        self.children = data;
        console.log('loaded childs' + data.length);
        if (self.treestate.path) {
          console.log('check tree path state after reload');
          self.checkpath(self.treestate.path);
        }
      });
    },
  }
}
</script>
